<select #container [disabled]="disabled" >
<!--   @for (option of options; track option.id) {
  <option [disabled]="option.disabled" value="{{option.id}}">{{option.text}}</option>
  } -->
</select>
